import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    "& .MuiFormControl-root": {
      display: "flex"
    }
  }
}));
